import React, { useContext, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { useHistory } from 'react-router-dom';
import context from '../../context.js'

const NotificationModal = ({ show, setModalShow, data }) => {
  const history = useHistory();
  const patient = useContext(context);

  useEffect(() => {
    patient.setData(data)
  }, [ show ])

  const redirectToClinic = (paramData) => {
    patient.setData({ ...paramData,payment_type_id:1 })
    history.push('/apm/clinic');
  }

  return (
    <Modal show={ show } onHide={ () => setModalShow(false) } backdrop='static'>
      <Modal.Body>
        <div className='row d-flex justify-content-center'>
          <span className='text-warning'>
            <i className='fas fa-exclamation-triangle fa-3x'></i>
          </span>
        </div>
        <div className='row d-flex justify-content-center mt-3'>
          <h2>Nomor BPJS Tidak Aktif ATAU Anda Bukan Peserta Faskes Ini...</h2>
        </div>
      </Modal.Body>

      <div className='row my-3'>
        <div className='col d-flex justify-content-around'>
          <Button
            variant='danger'
            onClick={ () => {
              history.push('/apm/registration');
              setModalShow(false);
            } }>
            Ke Bagian Pendaftaran
          </Button>
          <Button
            variant='primary'
            onClick={ () => redirectToClinic(data) }>
            Daftar Sebagai Pasien Umum
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default NotificationModal;
